/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_LengthInputs */

const en_field_length = /** @type {(inputs: Field_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Length`)
};

const es_field_length = /** @type {(inputs: Field_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eslora/Longitud`)
};

const fr_field_length = /** @type {(inputs: Field_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Longueur`)
};

const de_field_length = /** @type {(inputs: Field_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Länge`)
};

const ja_field_length = /** @type {(inputs: Field_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`長さ`)
};

const zh_field_length = /** @type {(inputs: Field_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`长度`)
};

const ar_field_length = /** @type {(inputs: Field_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الطول`)
};

const id_field_length = /** @type {(inputs: Field_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Panjang`)
};

const it_field_length = /** @type {(inputs: Field_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lunghezza`)
};

const ru_field_length = /** @type {(inputs: Field_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Длина`)
};

const pt_field_length = /** @type {(inputs: Field_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comprimento`)
};

const ko_field_length = /** @type {(inputs: Field_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`길이`)
};

/**
* | output |
* | --- |
* | "Length" |
*
* @param {Field_LengthInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_length = /** @type {((inputs?: Field_LengthInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_LengthInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_length(inputs)
	if (locale === "es") return es_field_length(inputs)
	if (locale === "fr") return fr_field_length(inputs)
	if (locale === "de") return de_field_length(inputs)
	if (locale === "ja") return ja_field_length(inputs)
	if (locale === "zh") return zh_field_length(inputs)
	if (locale === "ar") return ar_field_length(inputs)
	if (locale === "id") return id_field_length(inputs)
	if (locale === "it") return it_field_length(inputs)
	if (locale === "ru") return ru_field_length(inputs)
	if (locale === "pt") return pt_field_length(inputs)
	return ko_field_length(inputs)
});